import LineCompassIcon from 'components/Luxkit/Icons/line/LineCompassIcon'
import TextLink from 'components/Luxkit/TextLink'
import React, { useCallback, useContext } from 'react'
import AdditionalWaysToExperienceMessagingTile from './AdditionalWaysToExperienceMessagingTile'
import ModalContext from 'contexts/ModalContext'
import RequestAgentCallbackModal from 'supportAssistant/components/RequestAgentCallback/Modals/RequestAgentCallbackModal'

function PrivateDepartureMessagingTile() {
  const showModal = useContext(ModalContext)
  const openCallbackRequestModal = useCallback(() => {
    showModal(<RequestAgentCallbackModal type="TOURS" />)
  }, [showModal])

  return <AdditionalWaysToExperienceMessagingTile
    heading="Private Departure"
    description="Travel exclusively with family and friends at a time that works best for you."
    Icon={LineCompassIcon}
    action={<TextLink size="small" onClick={openCallbackRequestModal}>Submit a request</TextLink>}
  />
}

export default PrivateDepartureMessagingTile
